import React from 'react';
import ErrorPage from '../vendor/pages/ErrorPage/ErrorPage';

const ErrorView = ({ children = <ErrorPage /> }) => {
    return <div>{children}</div>;
};

export default ErrorView;
